import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
const ILanguageService = ( createDecorator('languageService'));
export { ILanguageService };
